import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Card, CardBody, FormText, Input } from "reactstrap";
import CustomDatePickerV2 from "../../common/commonComponents/CustomDatePicker-V2/index";
const timepickerStyle = {
  "& .MuiInputBase-input": {
    height: "20px",
    padding: "10px",
  },
  "& .MuiOutlinedInput-root:not(.Mui-error)": {
    "& fieldset": {
      borderColor: "#00b0f5",
    },
    "&:hover fieldset": {
      borderColor: "#00b0f5",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00b0f5",
    },
    "& .MuiSvgIcon-root": {
      color: "#00b0f5",
    },
  },
};

const SchedulerDateTime = ({
  testData,
  minTime = new moment(),
  maxTime = new moment(),
  field = "",
  onDateTimeChange = () => {},
}) => {
  const [startDate, setStartDate] = useState(new moment());
  const [startTime, setStartTime] = useState(new moment());
  const [isScheduled, setIsScheduled] = useState(false);

  useEffect(() => {
    if (isScheduled && startDate && startTime) {
      const combined = moment(startDate).set({
        hour: moment(startTime).get("hour"),
        minute: moment(startTime).get("minute"),
        second: 0,
        millisecond: 0,
      });
      console.log("Combined DateTime:", combined.valueOf(), combined.format());
      onDateTimeChange(combined.valueOf());
    } else if (!isScheduled) {
      onDateTimeChange(null);
    }
  }, [startDate, startTime, isScheduled]);

  return (
    <Card style={{ marginBottom: 10 }}>
      <div
        style={{
          backgroundColor: "#FFF",
          padding: "10px 15px",
          borderBottom: "1px solid #E0E0E0",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            color: "#212121",
            fontWeight: 500,
            lineHeight: "24px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <div className="custom-control custom-checkbox">
            <Input
              type="checkbox"
              id="isScheduledCheckbox"
              className="custom-control-input"
              checked={isScheduled}
              onChange={(e) => setIsScheduled(e.target.checked)}
            />
            <label htmlFor="isScheduledCheckbox" className="custom-control-label" style={{ fontSize: "16px", fontWeight: 500, color: "#212121", lineHeight: "24px" }}>
              Schedule Date & Time
            </label>
          </div>
        </div>
      </div>
      {isScheduled && (
        <CardBody>
          <LocalizationProvider dateAdapter={AdapterMoment}>
          <div className="d-flex flex-row" style={{ gap: "20px" }}>
            <div>
              <div
                className="mb-1"
                style={{
                  fontSize: "14px",
                  color: "#757575",
                  fontWeight: 400,
                  lineHeight: "16px",
                }}
              >
                Select Date
              </div>
              <div>
                <CustomDatePickerV2
                  InputFontSize="15px"
                  placeHolder="Select start date"
                  value={moment(startDate)}
                  handler={(i, date) => {
                    console.log("Selected end time:", date);
                    const selectedStartDate = moment(date);
                    setStartDate(selectedStartDate);
                  }}
                  minDate={new moment()}
                  maxDate={moment(new Date()).add(90, "days")}
                />
              </div>
            </div>
            <div>
              <div
                className="mb-1"
                style={{
                  fontSize: "14px",
                  color: "#757575",
                  fontWeight: 400,
                  lineHeight: "16px",
                }}
              >
                Select time
              </div>
              <div>
                <TimePicker
                  ampm={true}
                  value={moment(startTime)}
                  onChange={(value) => {
                    console.log("Selected end time:", value);
                    const selectedEndTime = moment(value);
                    setStartTime(selectedEndTime);
                  }}
                  timeSteps={{ minutes: 15 }}
                  minTime={
                    moment(startDate).isSame(moment(), "day")
                      ? minTime
                      : undefined
                  }
                  sx={timepickerStyle}
                  disableIgnoringDatePartForTimeValidation
                  shouldDisableTime={(value, view) =>
                    view === "minutes" && value.minute() % 15 !== 0
                  }
                  slotProps={{ textField: { size: "small", readOnly: true } }}
                />
              </div>
            </div>
          </div>
          <FormText className="text-info">
              <span style={{color: "red"}}>*</span>
              {`Dates can be selected up to 90 days, and times can be set in 15-minute intervals. You may cancel this up to 5 minutes before the scheduled time.`}
            </FormText>
          </LocalizationProvider>
        </CardBody>
      )}
    </Card>
  );
};

export default SchedulerDateTime;
